import React, { useState } from "react";
import { Accordion, Card, Button } from "react-bootstrap";

const Index = () => {
  const [activeTab, setActiveTab] = useState("0");

  return (
    <div className="tab-section-container">
      <div className="inner-tab-section-container">
        <p className="introduction-text">
          Biblioteket er Leadfind sin sky-baserte fildelingstjeneste, og lar deg
          laste opp og lagre viktige filer. Dette er et bra verktøy for å sikre
          seg umiddelbar tilgang til dokumenter, uansett hvilken enhet man
          benytter seg av eller hvor man måtte befinne seg i verden. Alle filene
          du lastes opp blir trygt lagret og kryptert.
          <br />
          <br />
          Det er ikke alltid ønskelig at filene man laster opp på biblioteket
          skal kunne bli gjort tilgjengelig for alle, og derfor har man mulighet
          til å passordbeskytte filene. Da vil kun de med passord ha mulighet
          til å få tilgang til selve filen, men samtidig også fjerne passordet.
        </p>
        <div className="accordion-container">
          <Accordion
            className="company-accordion"
            defaultActiveKey="0"
            activeKey={activeTab}
          >
            <Card className="single-card top">
              <Card.Header className="card-header">
                <Accordion.Toggle
                  className="card-toggle"
                  as={Button}
                  variant="link"
                  eventKey="0"
                  onClick={() => setActiveTab("0")}
                >
                  <button
                    className={`collapse-button ${
                      activeTab === "0" ? "active" : ""
                    }`}
                  >
                    {activeTab === "0" ? (
                      <i class="fas fa-minus"></i>
                    ) : (
                      <i class="fad fa-plus"></i>
                    )}
                  </button>
                  Last opp en fil
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body className="card-body">
                  <p className="description-text">
                    Det er enkelt å laste opp en fil til biblioteket, slik gjør
                    du det:
                  </p>
                  <ol className="description-list">
                    <li>
                      Gå til <span className="bold">"Bibliotek"</span> fra
                      menyen til venstre.
                    </li>
                    <li>
                      Trykk på <span className="bold">Last opp</span>-knappen
                      øverst til høyre.
                    </li>
                    <li>Dra og slipp ønsket fil i boksen med grå kanter.</li>
                    <li>
                      Trykk til slutt på{" "}
                      <span className="bold">"Last opp"</span>-knappen.
                    </li>
                  </ol>
                  <p className="description-text">
                    Avhengig av filstørrelse kan opplastingstiden variere. Når
                    opplasting er ferdig vil biblioteket oppdatere seg, og filen
                    vises i listen sammen med de andre filene du har lastet opp
                    tidligere.
                  </p>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card className="single-card top">
              <Card.Header className="card-header">
                <Accordion.Toggle
                  className="card-toggle"
                  as={Button}
                  variant="link"
                  eventKey="1"
                  onClick={() => setActiveTab("1")}
                >
                  <button
                    className={`collapse-button ${
                      activeTab === "1" ? "active" : ""
                    }`}
                  >
                    {activeTab === "1" ? (
                      <i class="fas fa-minus"></i>
                    ) : (
                      <i class="fad fa-plus"></i>
                    )}
                  </button>
                  Passordbeskytt en fil
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="1">
                <Card.Body className="card-body">
                  <p className="description-text">
                    Man kan ønske å passordbeskytte en fil av forskjellige
                    grunner, og man kan gjøre dette på to forskjellige måter.
                    Slik går du frem for å passordbeskytte en fil:
                  </p>
                  <h5 className="description-subtitle">Ved opplasting</h5>
                  <p className="description-text">
                    Følg samme fremgangsmetode som vist over i en standard
                    filopplasting, og velg ønsket fil.
                  </p>
                  <ol className="description-list">
                    <li>
                      Huk deretter av{" "}
                      <span className="bold">"Passordbeskyttet"</span> under{" "}
                      <span className="bold">"Innstillinger"</span> i feltet
                      under.
                    </li>
                    <li>
                      Skriv inn et passord på minst 6 tegn og gjenta det i
                      tekstfeltet ved siden av.
                    </li>
                    <li>
                      Trykk til slutt på{" "}
                      <span className="bold">"Last opp"</span>-knappen.
                    </li>
                  </ol>
                  <h5 className="description-subtitle">
                    Gjennom innstillinger
                  </h5>
                  <p className="description-text">
                    Gå først til <span className="bold">"Bibliotek"</span> fra
                    menyen til venstre, og gjør følgende:
                  </p>
                  <ol className="description-list">
                    <li>
                      Trykk på penn-ikonet til høyre for navnet på filen du
                      ønsker å passordbeskytte.
                    </li>
                    <li>
                      Huk deretter av{" "}
                      <span className="bold">"Passordbeskyttet"</span> under{" "}
                      <span className="bold">"Innstillinger"</span> i feltet
                      under.
                    </li>
                    <li>
                      Skriv inn et passord på minst 6 tegn og gjenta det i
                      tekstfeltet ved siden av.
                    </li>
                    <li>
                      Trykk til slutt på{" "}
                      <span className="bold">"Last opp"</span>-knappen.
                    </li>
                  </ol>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card className="single-card">
              <Card.Header className="card-header">
                <Accordion.Toggle
                  className="card-toggle"
                  as={Button}
                  variant="link"
                  eventKey="2"
                  onClick={() => setActiveTab("2")}
                >
                  <button
                    className={`collapse-button ${
                      activeTab === "2" ? "active" : ""
                    }`}
                  >
                    {activeTab === "2" ? (
                      <i class="fas fa-minus"></i>
                    ) : (
                      <i class="fad fa-plus"></i>
                    )}
                  </button>
                  Fjern passordbeskyttelse
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="2">
                <Card.Body className="card-body">
                  <p className="description-text">
                    Fjerne passordbeskyttelse på fil er fort gjort, og slik går
                    du frem:
                  </p>
                  <ol className="description-list">
                    <li>
                      Trykk på penn-ikonet til høyre for navnet på filen du
                      ønsker å fjerne passordet på.
                    </li>
                    <li>
                      Skriv inn passordet til filen i de to tekstboksene som
                      vises.
                    </li>
                    <li>
                      Trykk til slutt på{" "}
                      <span className="bold">"Fjern passord"</span>-knappen.
                    </li>
                  </ol>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card className="single-card last">
              <Card.Header className="card-header">
                <Accordion.Toggle
                  className="card-toggle"
                  as={Button}
                  variant="link"
                  eventKey="3"
                  onClick={() => setActiveTab("3")}
                >
                  <button
                    className={`collapse-button ${
                      activeTab === "3" ? "active" : ""
                    }`}
                  >
                    {activeTab === "3" ? (
                      <i class="fas fa-minus"></i>
                    ) : (
                      <i class="fad fa-plus"></i>
                    )}
                  </button>
                  Slett fil
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="3">
                <Card.Body className="card-body">
                  <p className="description-text">
                    For å slette en fil i biblioteket ditt gjør du slik:
                  </p>
                  <ol className="description-list">
                    <li>
                      Trykk på søppeldunk-ikonet til høyre for navnet på filen
                      du ønsker å fjerne.
                    </li>
                    <li>
                      Trykk så på <span className="bold">Ja, slett filen</span>
                      -knappen.
                    </li>
                  </ol>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </div>
      </div>
    </div>
  );
};

export default Index;
